<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('missing.Missing_reason') }}</h5>  
    <p class="mb-0 text-sm">{{ $t('common.Mandatory_informations') }} *</p>  
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <div class="col-8">
            <div class="input-group input-group-static null">
                <label>{{ $t('missing.Missing_reason') }} *</label>
                <select id="missingReasonId" v-model="localFormData.missingReasonId" class="form-control form-control-default">
                    <option value="">{{ $t('missing.Select_missing_reason') }}</option>
                    <option v-for="item in missingreasons" :key="item.id" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
                <span v-if="v$.missingReasonId.$error" class="text-sm text-danger">
                      {{ v$.missingReasonId.$errors[0].$message }}
                  </span>
            </div>
        </div>        
      </div>      
      <div class="row mt-3">
          <div class="col-12 text-success">
              {{ $t('missing.Check_the_data_of_the_animals_to_be_missed_before_you_save') }}        
          </div>
      </div>   
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="validateAndPrevStep">{{ $t('common.Prev') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, reactive, watch } from 'vue'
  import useVuelidate from '@vuelidate/core'
  import { required, helpers } from '@vuelidate/validators'
  import { useI18n } from 'vue-i18n'

  export default {
    name: "ReasonInfo",
    props: {
      missingreasons: Array,      
      formData: Object,
      prevStep: Function,
      nextStep: Function
    },
    setup(props, { emit }) {   
      const { t } = useI18n()   
      const localFormData = reactive(props.formData);

      const rules = computed(() => {
          return {
              missingReasonId: { required: helpers.withMessage(t('common.Required'), required) }
          }
      })  

      const v$ = useVuelidate(rules, localFormData)

      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      const validateAndPrevStep = async () => {
        v$.value.$touch()
        if (v$.value.$pending) {
          await v$.value.$validate()
        }
        if (!v$.value.$invalid) {
          Object.assign(props.formData, localFormData)
          props.prevStep()
        }         
      }

      const validateAndSubmit = async () => {        
        v$.value.$touch()
        const isValid = await v$.value.$validate()
        if (!isValid) return

        console.log('here');

        Object.assign(props.formData, localFormData)
        emit('submit')
        return true        
      }     

      return {
        localFormData,    
        v$,           
        validateAndPrevStep,
        validateAndSubmit
      }
    }    
};
</script>
<style scoped>
.card {
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  position: relative;
  padding: 10px !important;
}
.cursor-pointer {
  cursor: pointer;
}
.bg-light {
  background-color: #f9f9f9 !important;
}
.border-success {
  border-color: #28a745 !important;
}
</style>